/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useCallback, useEffect } from "react";
import callApi from "../../utils/apiCaller";
import Swal from "sweetalert2";
import uuid from "uuid-random";
import {
  DeleteMajor,
  DomainNewMajor,
  DuplicateMinor,
  ExchangeMajor,
  ExistingInventoryMajor,
  FlagMajor,
  ImportMinor,
  UploadMajor,
} from "@shopify/polaris-icons";
import moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  Button,
  Card,
  Banner,
  Icon,
  Modal,
  Badge,
  Link,
  TextContainer,
  TextField,
  Checkbox,
  Heading,
  Toast,
  Frame,
  Select,
} from "@shopify/polaris";
import { Row, Table, Col } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { actFetchShowLoadingPage } from "../../actions";
import PlanTable from "../Dashboard/PlanTable";

const BannerDispute = () => {
  const [modalDisputeState, setmodalDisputeState] = useState(false);
  const [modalPlan, setModalPlan] = useState(false);
  const [paypalAccountSelected, setpaypalAccountSelected] = useState("");
  const [paypalAccount, setPayPalAccount] = useState([]);
  const [timeRange, settimeRange] = useState("30");
  const listPayPalAccounts = useSelector((state) => state.listPayPalAccounts);
  const dataSettings = useSelector((state) => state.dataSettings);
  const dispatch = useDispatch();

  const getDispute = async () => {
    let params = {
      action: "getDispute",
      payerId: paypalAccountSelected,
      timeRange: timeRange,
    };
    dispatch(actFetchShowLoadingPage(true));
    await callApi("get", params).then(async (res) => {
      if (res.data.state === 1) {
        setmodalDisputeState(false);
        Swal.fire({
          icon: "success",
          title: "Successfully",
          text: res.data.msg,
          showCloseButton: false,
          showConfirmButton: false,
          timer: 3000,
        }).then((result) => {
          window.location.reload();
        });
      }
      dispatch(actFetchShowLoadingPage(false));
    });
  };

  const openModal = async () => {
    if (
      dataSettings.plan !== "free" ||
      dataSettings.marketing_campaign == "2"
    ) {
      setmodalDisputeState(true);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Need to upgrade Plan!",
        html: "PayPal dispute management is only available for the <b>Basic plan or higher</b>. You need to upgrade your package to use.",
        showCancelButton: true,
        confirmButtonText: "Pick a higher plan",
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          setModalPlan(true);
        }
      });
    }
  };

  useEffect(() => {
    let paypalAccount = getUnique(listPayPalAccounts, "payer_id");
    let PayPalAccountArr = [];
    if (paypalAccount.length > 0) {
      for (let i = 0; i < paypalAccount.length; i++) {
        let account = {
          label: paypalAccount[i].payer_id,
          value: paypalAccount[i].payer_id,
        };
        PayPalAccountArr.push(account);
      }
    }
    setPayPalAccount(PayPalAccountArr);
  }, [listPayPalAccounts]);

  useEffect(() => {
    if (dataSettings.plan == "free" && dataSettings.marketing_campaign != "2") {
      Swal.fire({
        icon: "warning",
        title: "Need to upgrade Plan!",
        html: "PayPal dispute management is only available for the <b>Basic plan or higher</b>. You need to upgrade your package to use.",
        showCancelButton: true,
        confirmButtonText: "Pick a higher plan",
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          setModalPlan(true);
        }
      });
    } else {
      if (typeof window.$crisp != undefined && window.$crisp != undefined) {
        window.$crisp.push(["set", "session:event", ["Synctrack-dispute"]]);
      }
    }
  }, [dataSettings.plan]);

  useEffect(() => {
    if (paypalAccount.length > 0) {
      setpaypalAccountSelected(paypalAccount[0].value);
    }
  }, [paypalAccount]);

  return (
    <div style={{ marginTop: "20px" }} className="settings-page">
      <Banner status="success" icon={FlagMajor}>
        <Row>
          <Col md={8}>
            <span>
              The dispute management dashboard including{" "}
              <b> dispute status, dispute reason, update time, amount, etc</b>.
              would be displayed, click the <b>right button</b> to show it.
              <br />
              We currently need{" "}
              <b>more ideas to expand the features related to PayPal dispute</b>
              , if you have <b>any ideas or wishes</b>, do not hesitate to{" "}
              <b>share with us via chat</b>.
            </span>
          </Col>
          <Col md={4}>
            <div className="float-right">
              <Button icon={ImportMinor} primary onClick={() => openModal()}>
                Get disputes from PayPal
              </Button>
            </div>
          </Col>
          <Modal
            open={modalDisputeState}
            onClose={() => setmodalDisputeState(false)}
            title="Get dispute infomation from your PayPal accounts"
            primaryAction={{
              content: "Start",
              onAction: () => getDispute(),
            }}
            secondaryActions={[
              {
                content: "Cancel",
                onAction: () => setmodalDisputeState(false),
              },
            ]}
          >
            <Modal.Section>
              <Select
                label="PayPal account"
                options={paypalAccount}
                onChange={setpaypalAccountSelected}
                value={paypalAccountSelected}
              />
              <TextField
                label="How many days would you like to get dispute data?"
                value={timeRange}
                suffix="days"
                onChange={settimeRange}
                autoComplete="off"
              />
            </Modal.Section>
          </Modal>
          {/* <Modal
            open={modalDisputeNoti}
            onClose={() => setmodalDisputeNoti(false)}
            title="Get dispute infomation from your PayPal accounts"
            primaryAction={{
              content: "Pick a higher plan",
              onAction: () => pickPlan(),
            }}
          >
            <Modal.Section>
              <Banner
                title=""
                status="Warning"
              ></Banner>
            </Modal.Section>
          </Modal> */}
          <Modal
            large={true}
            open={modalPlan}
            onClose={() => setModalPlan(false)}
            title="Pricing Table"
            secondaryActions={[
              {
                content: "Cancel",
                onAction: () => setModalPlan(false),
              },
            ]}
          >
            <Modal.Section>
              <PlanTable type="step" />
            </Modal.Section>
          </Modal>
        </Row>
      </Banner>
    </div>
  );
};

export default BannerDispute;

function getUnique(arr, comp) {
  const unique = arr
    .map((e) => e[comp])

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter((e) => arr[e])
    .map((e) => arr[e]);

  return unique;
}
